import React from 'react'
import { useTranslation } from 'react-i18next'
import { ShieldCheck, RefreshCw, ClockArrowUp, Loader2 } from 'lucide-react'
import { useSync } from '../../../../hooks/useSync'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '../../../ui/dialog'
import './ServerStatusDialog.scss'

interface ServerStatusDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
}

export const ServerStatusDialog: React.FC<ServerStatusDialogProps> = ({ open, onOpenChange }) => {
  const { t } = useTranslation()
  const { syncState, nextRetryIn } = useSync()
  const pendingCount = syncState.pendingChanges

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="server-status-dialog">
        <DialogHeader>
          <DialogTitle>{t('sync.serverStatus.title')}</DialogTitle>
          <DialogDescription>{t('sync.serverStatus.description')}</DialogDescription>
        </DialogHeader>

        {/* Retry Countdown */}
        <div className="server-status-dialog__retry">
          <Loader2 size={16} className="server-status-dialog__spinner" />
          <span className="server-status-dialog__retry-text">
            {t('sync.serverStatus.retryIn', { seconds: nextRetryIn })}
          </span>
        </div>

        {/* Details Section */}
        <div className="server-status-dialog__details">
          <h3 className="server-status-dialog__details-title">
            {t('sync.serverStatus.detailsTitle')}
          </h3>

          <div className="server-status-dialog__card">
            <ShieldCheck size={20} className="server-status-dialog__card-icon server-status-dialog__card-icon--safe" />
            <div className="server-status-dialog__card-body">
              <p className="server-status-dialog__card-title">
                {t('sync.serverStatus.dataSafe.title')}
              </p>
              <p className="server-status-dialog__card-text">
                {t('sync.serverStatus.dataSafe.text')}
              </p>
            </div>
          </div>

          <div className="server-status-dialog__card">
            <RefreshCw size={20} className="server-status-dialog__card-icon server-status-dialog__card-icon--sync" />
            <div className="server-status-dialog__card-body">
              <p className="server-status-dialog__card-title">
                {t('sync.serverStatus.autoSync.title')}
              </p>
              <p className="server-status-dialog__card-text">
                {t('sync.serverStatus.autoSync.text')}
              </p>
            </div>
          </div>

          <div className="server-status-dialog__card">
            <ClockArrowUp size={20} className="server-status-dialog__card-icon server-status-dialog__card-icon--pending" />
            <div className="server-status-dialog__card-body">
              <p className="server-status-dialog__card-title">
                {t('sync.serverStatus.pending.title')}
              </p>
              <p className="server-status-dialog__card-text">
                {pendingCount > 0
                  ? t('sync.serverStatus.pending.textWithCount', { count: pendingCount })
                  : t('sync.serverStatus.pending.textNone')
                }
              </p>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
